import Script from "next/script";
import type { FunctionComponent } from "react";

export const OnePlusXScripts: FunctionComponent = () => (
  <>
    <Script id="one-plus-x" src="https://cdn.opecloud.com/ope-scmp.js" strategy="lazyOnload" />
    <Script
      dangerouslySetInnerHTML={{
        __html: `
          ope("scmp", "init", "implied",{
            "taggerUrl": "https://tagger.ope.scmp.com/",
            "profileApiUrl": "https://profiles.ope.scmp.com/api/v1/scmp/profile",
            "visitProvider": "cmd"
          });
        `,
      }}
      id="one-plus-x-after-script"
      strategy="lazyOnload"
    />
  </>
);

OnePlusXScripts.displayName = "OnePlusXScripts";
